<div class="wrapper">
  <div class="header">
    <div class="title">
      {{ section.header }}
    </div>
  </div>

  <div class="card-wrapper" *ngIf="!isMobile">
    <ng-container *ngTemplateOutlet="commonTemplate"></ng-container>
  </div>

  <div class="card-wrapper" *ngIf="isMobile">
    <ngx-glide [showArrows]="false" [showBullets]="false" [perView]="1.8" [bound]="true" [dragThreshold]="false" [breakpoints]="breakpoints" [perTouch]="1">
      <ng-container *ngTemplateOutlet="commonTemplate"></ng-container>
    </ngx-glide>
  </div>

  <div class="description">
    {{section.desc}}
  </div>
</div>

<ng-template #commonTemplate>
  <div class="card" *ngFor="let item of section.data_list"> 
    <div [class]="'sprite-bg ' + item.icon">
    </div>
    <div class="hr"></div>
    <div class="title">
      {{item.text}}
    </div>
  </div>
</ng-template>